import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth, formatApiError } from "../lib/auth";
import BrandHeader from "../components/brand/BrandHeader";
import Footer from "../components/brand/Footer";
import { formatMoney } from "../lib/brand";
import { toast } from "sonner";
import { Drop, CaretRight } from "@phosphor-icons/react";

export default function HydroApply() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({
    full_name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
    city: "",
    notes: "",
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get("/settings/payment").then(({ data }) => setSettings(data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.full_name.trim() || !form.email.trim() || !form.phone.trim()) {
      toast.error("Full name, email and phone are required");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/hydro/apply", form);
      toast.success("Application received. Continue to payment.");
      nav(`/hydro/payment/${data.id}`);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      <BrandHeader />
      <section className="max-w-2xl mx-auto px-6 py-12">
        <div className="text-center mb-8 rise-in">
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gold-gradient text-black mb-3">
            <Drop size={22} weight="duotone" />
          </div>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Hydro Membership</p>
          <h1 className="font-display text-4xl sm:text-5xl text-white mt-2">Apply in under a minute.</h1>
          <p className="text-white/60 mt-3">
            Fill in your details below. Next step is payment via GCash and our team will verify your Hydro Membership.
          </p>
          {settings?.hydro_membership_price > 0 && (
            <p className="text-[#D4AF37] mt-2 text-sm">Membership fee · {formatMoney(settings.hydro_membership_price)}</p>
          )}
        </div>

        <form onSubmit={submit} className="tsc-card p-6 sm:p-8 space-y-5" data-testid="hydro-apply-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Full name *</label>
              <input required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="tsc-input mt-1.5" placeholder="Your full name" data-testid="hydro-apply-name" />
            </div>
            <div>
              <label className="text-[10px] tracking-luxe uppercase text-white/60">Phone *</label>
              <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="tsc-input mt-1.5" placeholder="+63 ..." data-testid="hydro-apply-phone" />
            </div>
          </div>
          <div>
            <label className="text-[10px] tracking-luxe uppercase text-white/60">Email *</label>
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="tsc-input mt-1.5" placeholder="you@email.com" data-testid="hydro-apply-email" />
          </div>
          <div>
            <label className="text-[10px] tracking-luxe uppercase text-white/60">City</label>
            <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="tsc-input mt-1.5" placeholder="City" data-testid="hydro-apply-city" />
          </div>
          <div>
            <label className="text-[10px] tracking-luxe uppercase text-white/60">Anything else? (optional)</label>
            <textarea rows="3" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="tsc-input mt-1.5" placeholder="Anything you want our team to know" data-testid="hydro-apply-notes" />
          </div>
          <p className="text-white/40 text-[11px]">By submitting, you agree to be contacted by our team for Hydro Membership activation.</p>
          <button type="submit" disabled={submitting} className="tsc-btn-gold w-full flex items-center justify-center gap-2" data-testid="hydro-apply-submit">
            {submitting ? "Submitting…" : <>Continue to payment <CaretRight size={14} weight="bold" /></>}
          </button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
